import { Controller } from "@hotwired/stimulus"

// Flash toast (docs/DESIGN_SYSTEM.md §4.2): manual dismiss, leave animation,
// and a 6s timeout for notices only.
//
// Alerts do not expire. Six seconds was the entire lifespan of every error
// message in the app — validation failures, authorization denials, "the page
// may be out of date" — after which they were removed from the DOM with no
// history anywhere, so anyone who looked away lost both the message and the
// reason for it. A notice confirms something the user just did, so those can
// still go; hovering or focusing one holds it while it is being read.
export default class extends Controller {
  static values = { severity: { type: String, default: "notice" } }

  static TIMEOUT = 6000

  connect() {
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  schedule() {
    if (this.severityValue === "alert") return

    this.timeout = setTimeout(() => this.dismiss(), this.constructor.TIMEOUT)
  }

  hold() {
    clearTimeout(this.timeout)
  }

  resume() {
    this.schedule()
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("toast-leaving")
    setTimeout(() => this.element.remove(), 200)
  }
}
